import React, { useState } from "react";
import { Sheet } from "@c4c-web/ui";
// import { useAnalytics } from "@c4c-web/core/hooks/analytics";
// import {
//   EAnalyticsEvent,
//   EAnalyticsEventAction,
//   EAnalyticsEventCategory,
// } from "@c4c-web/core/constants";
import type { IAddress, ILocation, TranslationFn } from "../../../types";
import type { IUseAddressFormSetters } from "../../../hooks";
// import { getDefaultAddressAnalyticsParams } from "../../../utils";
import {
  // EAnalyticsEventLabel,
  // EAnalyticsScreenName,
  type EStoreIds,
} from "../../../constants";
import { AddressSelectorMap } from "../MapSheet/AddressSelectorMap";
import {
  getAddressPayload,
  saveAddressFormData,
} from "./confirm-address.helper";
import { ConfirmAddressFooter } from "./ConfirmAddressFooter";
import { ConfirmAddressErrorMessage } from "./ConfirmAddressErrorMessage";
import { ConfirmAddressSummary } from "./ConfirmAddressSummary";

interface IConfirmAddressProps {
  address: IAddress;
  addressFormSetters: IUseAddressFormSetters;
  clearForm?: () => void;
  coordinates?: ILocation;
  onOpenChange: (value: boolean) => void;
  open?: boolean;
  openAddressForm?: (value: boolean) => void;
  storeId: EStoreIds;
  t: TranslationFn;
}

export const ConfirmAddress: React.FC<IConfirmAddressProps> = ({
  address,
  addressFormSetters,
  clearForm,
  coordinates,
  onOpenChange,
  open,
  openAddressForm,
  storeId,
  t,
}) => {
  // const { sendEvent } = useAnalytics();
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errorAddingAddress, setErrorAddingAddress] = useState(false);

  const handleCancel = (): void => {
    onOpenChange(false);
    clearForm && clearForm();
  };

  const onSuccess = (): void => {
    onOpenChange(false);
    clearForm && clearForm();
    setErrorAddingAddress(false);
    // sendEvent(
    //   {
    //     event: EAnalyticsEvent.Custom,
    //     event_action: EAnalyticsEventAction.AddressJourney,
    //     event_category: EAnalyticsEventCategory.UserEngagement,
    //     event_label: address.editInfo
    //       ? EAnalyticsEventLabel.SavedAddressUpdated
    //       : EAnalyticsEventLabel.NewAddressAdded,
    //   },
    //   getDefaultAddressAnalyticsParams(EAnalyticsScreenName.MyAddresses),
    // );
    window.location.reload();
  };

  const onFailure = (): void => {
    setErrorAddingAddress(true);
  };

  const handleSubmit = (): void => {
    setDisableSubmitButton(true);
    const payload = getAddressPayload(address, storeId);
    saveAddressFormData(
      onFailure,
      onSuccess,
      payload,
      storeId,
      address.editInfo,
    )
      .catch((error) => {
        // eslint-disable-next-line no-console -- logger
        console.error("Error saving form data", error);
        onFailure();
      })
      .finally(() => {
        setDisableSubmitButton(false);
      });
  };

  return (
    <Sheet
      className="h-full max-h-screen rounded-none md:w-[480px] md:rounded-l-2xl"
      footer={
        <ConfirmAddressFooter
          disableSubmitButton={disableSubmitButton}
          handleCancel={handleCancel}
          handleSubmit={handleSubmit}
          t={t}
        />
      }
      hideScrollBar
      id="confirm-address-sheet"
      onOpenChange={onOpenChange}
      open={open}
      title={t("addressJourney.addAddressDetails")}
    >
      {errorAddingAddress ? (
        <ConfirmAddressErrorMessage
          addressFormSetters={addressFormSetters}
          t={t}
        />
      ) : null}

      <div className="flex h-full flex-col justify-between gap-lg">
        <div className="flex flex-col gap-[20px]">
          <div className="h-[350px] overflow-hidden rounded-2xl border border-solid border-gray-100">
            <AddressSelectorMap
              defaultLocation={coordinates ?? { lat: 0, lng: 0 }}
              emirate={address.emirate}
              isConfirmAddress
              t={t}
              town={address.town}
            />
          </div>
          <ConfirmAddressSummary
            address={address}
            onOpenChange={onOpenChange}
            openAddressForm={openAddressForm}
            t={t}
          />
        </div>
      </div>
    </Sheet>
  );
};
